/* Greenhouse API Docs: https://github.com/grnhse/greenhouse-api-docs/blob/master/source/includes/job-board/_jobs.md */

const GREENHOUSE_API_URL = 'https://boards-api.greenhouse.io/v1/boards/';
export const SMAVA_BOARD_NAME = 'smavagmbh';
export const FFG_BOARD_NAME = 'finanzcheck';

/**
 * Returns a list of jobs from the given boardName
 * @param boardName
 * @returns
 */
export const getJobList = async (boardName: string) => {
  const response = await fetch(`${GREENHOUSE_API_URL}${boardName}/jobs`);
  const jobs = await response.json();
  return jobs.jobs;
};

/**
 * Returns a list of offices from the given boardName
 * @param boardName
 * @returns
 */
export const getOffices = async (boardName: string) => {
  const response = await fetch(`${GREENHOUSE_API_URL}${boardName}/offices`);
  const offices = await response.json();
  return offices.offices;
};

/**
 * Returns a job from the given boardName and jobId
 * @param boardName
 * @param jobId
 * @returns
 */
export const getJob = async (boardName: string, jobId: string) => {
  const response = await fetch(
    `${GREENHOUSE_API_URL}${boardName}/jobs/${jobId}`,
  );
  const job = await response.json();
  return job;
};

export const getLocationsFromJobList = (jobs: any) => {
  const locations: string[] = [];
  jobs.forEach((job: any) => {
    if (
      !locations.includes(job.location.name) &&
      job.location.name !== 'Germany'
    ) {
      // Germany is not a location, but a location category
      locations.push(job.location.name);
    }
  });
  return locations;
};

export const getCategoriesFromJobList = (jobs: any) => {
  const categories: string[] = [];
  jobs.forEach((job: any) => {
    const category = getCategoryFromJob(job);

    if (!categories.includes(category) && category !== 'Invisible') {
      categories.push(category);
    }
  });

  return categories;
};

export const getCategoryFromJob = (job: any): string => {
  const index = job.metadata.findIndex(
    (metaObj: any) => metaObj.name == 'Job Category',
  );
  const category = job.metadata[index].value.toString();

  return category;
};

export const getJobsFilteredByCategoryAndLocation = (
  jobs: any,
  filterCategory: string,
  filterLocation: string,
) => {
  const filteredJobs = jobs.filter((job: any) => {
    const jobCategory = getCategoryFromJob(job);
    const jobLocation = job.location.name;

    const isFittingLocation =
      jobLocation === filterLocation ||
      filterLocation === 'all' ||
      filterLocation === '';
    const isFittingCategory =
      jobCategory === filterCategory ||
      filterCategory === 'all' ||
      filterCategory === '';

    return isFittingLocation && isFittingCategory;
  });

  return filteredJobs;
};
/**
 * The Job Content is escaped, so it must be unescaped before insertion.
 * @param jobContent
 * @returns
 */
export const decodeJobContent = (jobContent: any) => {
  const doc = new DOMParser().parseFromString(jobContent, 'text/html');
  return doc.documentElement.textContent;
};

export const getJobApplicationIframeUrl = (
  boardName: string,
  jobId: string,
  source?: string,
) => {
  return `https://boards.greenhouse.io/embed/job_app?for=${boardName}&token=${jobId}&gh_src=${source}`;
};
